import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-950/95 backdrop-blur-sm border-b border-gray-800">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5 hover:opacity-80 transition-opacity"
        >
          <div className="w-7 h-7 bg-purple-600 rounded-md flex items-center justify-center flex-shrink-0">
            <span className="text-white font-bold text-xs">LC</span>
          </div>
          <span className="text-white font-semibold">LeetCode Solutions</span>
        </Link>

        <a
          href="https://leetcode.com/Rontaro"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-purple-400 hover:text-purple-300 text-sm font-medium transition-colors"
        >
          @Rontaro
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
